export const categories = [
  { id: 'affirmations',        name: 'Affirmations',        icon: 'Sparkles', accent: '#D6AD60', subtitle: 'Morning light' },
  { id: 'guided-meditations',  name: 'Guided Meditations',  icon: 'Brain',    accent: '#7a9b8e', subtitle: 'Midday stillness' },
  { id: 'sleep',               name: 'Sleep',               icon: 'Moon',     accent: '#1e3a5f', subtitle: 'Evening reset' },
  { id: 'anxiety',             name: 'Anxiety',             icon: 'Wind',     accent: '#a8bfae', subtitle: 'Healing & release' },
];

export const posts = {
  affirmations: [
    {
      id: 'one-thing-at-a-time',
      libraryRef: '803232be2eb74745baf8d56bae36dc31',
      title: 'One Thing At A Time',
      date: 'February 6, 2026',
      comments: 0,
      image: '/api/media/3f78c0701fb74e8f8af1c9223a9ea271',
      excerpt: 'You do not have to carry the whole list today. One breath, one step, one thing at a time.',
      content: 'The pressure you feel is not the day itself — it is you trying to hold every part of it at once.\n\nPut it down. Pick up one thing. Give it your full attention. Then the next.\n\nAffirm: I move one thing at a time. I do not have to hold it all. I trust that what needs me will find me when it is time.',
      category: 'affirmations',
    },
    {
      id: 'release-what-happened-earlier',
      libraryRef: 'c8a8cde10dd749b2af85e354800e36fe',
      title: 'Release What Happened Earlier',
      date: 'February 6, 2026',
      comments: 0,
      image: '/api/media/d2f53a4b93be42e2b80b7fae0a4cec5c',
      excerpt: 'Whatever happened earlier does not get to steal the rest of your day. You are allowed to reset.',
      content: 'That conversation, that mistake, that mood — it happened, and now it is behind you. You do not have to keep replaying it to prove you cared.\n\nExhale it out. Come back to right now.\n\nAffirm: I release what happened earlier. I am allowed to begin again. The rest of my day is still mine.',
      category: 'affirmations',
    },
    {
      id: 'for-now-i-breathe',
      libraryRef: '5057ef7461134a3aa323a9fbd5f3dd9a',
      title: 'For Now, I Breathe',
      date: 'August 17, 2026',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&q=80',
      excerpt: 'A gentle reminder that in this moment, you don\u2019t have to solve everything. All you have to do is breathe.',
      content: 'You do not have to figure it all out today. You do not have to be strong for everyone. Right now, in this moment, all you have to do is breathe.\n\nAffirm: For now, I breathe. For now, I am here. For now, that is enough.\n\nLet the next breath be the only thing you owe yourself right now.',
      category: 'affirmations',
    },
    {
      id: 'remember-to-breathe',
      libraryRef: '6675bb47d0d14b05ad0ac4c044a688bd',
      title: 'Remember To Breathe',
      date: 'August 17, 2026',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1518241353330-0f7941c2d9b5?w=600&q=80',
      excerpt: 'When life speeds up, come back to your breath. It has been waiting for you the whole time.',
      content: 'When the day feels loud, when the mind feels crowded, when your shoulders creep up toward your ears — remember to breathe.\n\nOne slow inhale. One long exhale. That is all it takes to come back to yourself.\n\nAffirm: I remember to breathe. My breath is home. My breath is enough.',
      category: 'affirmations',
    },
    {
      id: 'release-neck-tension',
      libraryRef: '20fbd9fc734948d58a70dc38056b9cf0',
      title: 'Release Neck Tension',
      date: 'August 17, 2026',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&q=80',
      excerpt: 'A soft affirmation for the tension you have been carrying — quite literally — in your neck and shoulders.',
      content: 'Notice where you are holding on. The jaw. The neck. The tops of the shoulders. That tension is your body carrying what your mind will not put down.\n\nRoll your shoulders back. Let them drop. Soften your jaw.\n\nAffirm: I release what I have been holding. I let my body soften. I do not have to carry this alone.',
      category: 'affirmations',
    },
    {
      id: 'sit-back',
      libraryRef: '20d671c94f2f49bd81d8041e7a42f003',
      title: 'Sit Back',
      date: 'August 17, 2026',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=600&q=80',
      excerpt: 'Not everything needs your reaction. Sometimes the most powerful thing you can do is sit back and let it unfold.',
      content: 'You do not have to jump into every fire. You do not have to answer every question. You do not have to prove anything to anyone today.\n\nSit back. Watch. Breathe. Trust that the right moment to act will make itself known.\n\nAffirm: I sit back. I trust the timing. I know when to move and when to rest.',
      category: 'affirmations',
    },
    {
      id: 'respond-accordingly',
      libraryRef: '23d9b37ab7b844a88129d0d1d26b4764',
      title: 'Respond Accordingly',
      date: 'August 17, 2026',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1490730141103-6cac27aaab94?w=600&q=80',
      excerpt: 'A grounding affirmation for the moments between what happens to you and what you choose to do next.',
      content: 'Between what happens and how you respond, there is a small, sacred space. That space is yours. Nobody can take it from you.\n\nIn that space, you get to choose. You get to breathe. You get to be the person you want to be — not the person the moment is trying to make you.\n\nAffirm: I respond accordingly. I choose my next move. I am steady in the space between.',
      category: 'affirmations',
    },
    {
      id: 'look-on-the-bright-side',
      libraryRef: '7eead7ed020949a79d3ea4c915c0a205',
      title: 'Look On The Bright Side',
      date: 'May 14, 2026',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1502082553048-f009c37129b9?w=600&q=80',
      excerpt: 'When clouds gather, there is still light waiting just behind them. This affirmation reminds you to lift your gaze and trust that brighter days are on their way.',
      content: 'Today, give yourself permission to see the good. Not because the hard things do not exist, but because focusing on the light helps you carry the heavy with more grace.\n\nThere is always something to be grateful for. The breath in your lungs. The roof over your head. The chance to begin again, in this very moment.\n\nAffirm: I choose to look on the bright side. I trust that something beautiful is unfolding, even when I cannot yet see it. The sun is still shining behind every cloud.\n\nTake a deep breath. Smile, even a small smile. Notice one thing — anything — that is good in your life right now. Hold onto it. Let it light the way.',
      category: 'affirmations',
    },
    {
      id: 'keep-going',
      libraryRef: '84732ce1526b4d7997b89adb17b61d8d',
      title: 'Keep Going',
      date: 'May 14, 2026',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?w=600&q=80',
      excerpt: 'Every step forward — no matter how small — is still a step forward. This is your reminder to keep going when the road feels long.',
      content: 'You have come further than you think.\n\nLook back at the version of you from a year ago. From five years ago. They could not imagine the things you have already overcome. And yet here you are — still standing, still trying, still showing up.\n\nKeep going. Not because it is easy, but because you are worth the life you are building.\n\nAffirm: I am stronger than I think. Every step matters. I do not have to do it all today — I just have to take the next step. And then the next.\n\nProgress does not have to be loud. Sometimes it looks like getting out of bed. Sometimes it looks like saying no. Sometimes it looks like breathing through one more hour. All of it counts. All of it is brave.\n\nKeep going. You are doing better than you know.',
      category: 'affirmations',
    },
    {
      id: 'unclench-your-jaw',
      libraryRef: '01e4560aa56b4effb2bde8dedca05a6d',
      title: 'Unclench Your Jaw',
      date: 'December 10, 2025',
      comments: 1,
      image: 'https://images.unsplash.com/photo-1604213410393-89f141bb96b8?w=600&q=80',
      excerpt: 'Release the tension you are holding in your jaw. This gentle reminder helps you let go of stress and find peace in your body.',
      content: 'Right now, in this moment, notice your jaw. Are your teeth clenched? Is there tension there?\n\nTake a deep breath and consciously relax your jaw. Let your tongue rest gently at the bottom of your mouth. Feel the space between your upper and lower teeth.\n\nRepeat this affirmation: I release what I cannot control. My body is safe. I allow myself to relax.\n\nThroughout your day, check in with your jaw. When you notice tension creeping back, take a breath and let it go. You do not have to hold everything so tightly. You are allowed to soften.',
      category: 'affirmations',
    },
    {
      id: 'stop-breathe',
      libraryRef: 'ab998add14a447a0b451c50a4dfad908',
      title: 'Stop. Breathe...',
      date: 'November 23, 2025',
      comments: 2,
      image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&q=80',
      excerpt: 'In the chaos of life, the simplest act can be the most powerful. Stop. Breathe. Reset. This is your permission to pause.',
      content: 'Stop. Just for a moment.\n\nFeel the air entering your lungs. Feel your chest rise and fall. You are alive. You are here. And that is enough.\n\nIn a world that constantly demands more from us, taking a breath is a radical act of self-care. You do not need to have it all figured out right now. You just need to breathe.\n\nAffirm: I give myself permission to rest. I am not falling behind by taking a pause. My breath is my anchor. I choose peace over perfection.\n\nRight now, wherever you are: Stop what you are doing. Place your hand on your heart. Feel it beating. You are alive. You are here.\n\nTake three deep breaths. Inhale peace. Exhale tension.',
      category: 'affirmations',
    },
    {
      id: 'not-as-it-seems',
      libraryRef: 'a5ad1b732702477caf998ca79521f582',
      title: 'Not As It Seems',
      date: 'November 21, 2025',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1612292741055-612f12bd0e50?w=600&q=80',
      excerpt: 'Things are not always what they appear to be. Look deeper. Look with your heart. This affirmation encourages perspective and deeper understanding.',
      content: 'The surface rarely tells the full story. A tree that appears barren in winter holds within it the promise of spring. A challenge that seems insurmountable today may be the very thing that shapes your greatest triumph.\n\nAffirm: I choose to look beyond the surface. I trust that there is more to my story than what I can see right now. Every ending is a new beginning. I am exactly where I need to be.',
      category: 'affirmations',
    },
  ],
  'guided-meditations': [
    {
      id: 'five-minute-reset',
      title: '5-Minute Reset',
      date: 'August 28, 2026',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=600&q=80',
      libraryRef: 'rowdy-for-now-just-breathe',
      duration: '5 min',
      tags: ['5-min'],
      excerpt: 'A quick five-minute meditation to reset your nervous system when the day feels loud. Short, gentle, and enough on its own.',
      content: 'Five minutes is enough.\n\nFind a place where you can be still — the corner of a couch, a parked car, the edge of your bed. Nothing has to change about your day. Just this small window.\n\nLet Rowdy’s video below guide the breath. All you have to do is stay with it. When your mind wanders — and it will — that\u2019s not failure, that\u2019s the practice. You come back. Again and again. Coming back IS the meditation.\n\nWhen the five minutes end, notice how your body feels. Then keep going with your day, softer than you started.',
      category: 'guided-meditations',
    },
    {
      id: 'grief-and-loss-meditation',
      libraryRef: '409804bee0e647e99a89710f1bac3ef6',
      title: 'Grief & Loss',
      date: 'August 14, 2026',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1447958272669-9c562446304f?w=600&q=80',
      excerpt: 'A tender guided meditation for moving through grief and loss. When the wave arrives, this practice offers a soft place to rest and remember you are held.',
      content: 'Grief is love with nowhere to land. This meditation makes room for that love, and for you.\n\nFind a place where you feel safe. Lie down, or sit — whichever your body asks for today. Let your hands rest somewhere gentle, maybe over your heart.\n\nBreathe in slowly. Breathe out slowly. There is no right way to grieve, and there is no wrong way to feel right now. Every wave that comes is proof of how deeply you loved.\n\nAs you breathe, allow whatever is present. The ache. The numbness. The memories. The silence. You do not have to push anything away, and you do not have to hold onto anything either.\n\nIf tears come, let them. If they don\u2019t, that\u2019s okay too. Your body knows the pace of your healing.\n\nRest here as long as you need. You are not alone in this. You are held — by breath, by memory, by the love that will always be yours.',
      category: 'guided-meditations',
    },
    {
      id: 'spiritual-healing',
      libraryRef: '600cac794b484b0dadd102fced5fb467',
      title: 'Spiritual Healing',
      date: 'November 21, 2025',
      comments: 1,
      image: 'https://images.unsplash.com/photo-1444703686981-a3abbc4d4fe3?w=600&q=80',
      excerpt: 'A guided meditation journey to heal your spirit and reconnect with your inner light. Allow yourself to be held in a space of pure love and healing energy.',
      content: 'Welcome to this guided meditation for spiritual healing.\n\nFind a comfortable position. Close your eyes. Take three deep breaths, each one deeper than the last.\n\nImagine a warm, golden light above your head. This light is pure love, pure healing energy. As you breathe in, this light begins to flow down through the crown of your head, filling every cell of your body with warmth and peace.\n\nLet this light wash away any pain, any worry, any heaviness you have been carrying. You are safe here. You are held. You are loved.\n\nWith each breath, feel yourself becoming lighter, more peaceful, more whole. Your spirit knows how to heal. Trust it. Allow it.',
      category: 'guided-meditations',
    },
    {
      id: 'depression',
      libraryRef: 'e5ede2544b6c4f89bc0049d1b58165f8',
      title: 'Depression',
      date: 'April 6, 2026',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1512438248247-f0f2a5a8b7f0?w=600&q=80',
      excerpt: 'A gentle guided meditation designed to bring light into the darkness. This practice offers compassion, hope, and a path forward when everything feels heavy.',
      content: 'This meditation is for you if you are carrying a heavy weight today. You do not have to carry it alone.\n\nSit or lie down in a comfortable position. Close your eyes gently. There is no pressure here. No expectations. Just you, and this moment.\n\nBreathe in slowly. Breathe out slowly. With each exhale, imagine releasing just a tiny bit of the heaviness. You do not need to release it all at once. Just a little at a time.\n\nNow, imagine a small flame in the center of your chest. It may be dim, but it is there. This flame is your hope, your resilience, your will to keep going. Feed it with your breath. Watch it grow, slowly, gently.\n\nYou are not broken. You are healing. And healing is not linear.',
      category: 'guided-meditations',
    },
    {
      id: 'anxiety-meditation',
      libraryRef: '351679abd23b4b2db45be6882c26cd2d',
      title: 'Anxiety',
      date: 'April 4, 2026',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1484766280341-87861644c80d?w=600&q=80',
      excerpt: 'A calming guided meditation to help you release anxious thoughts and find your center. Break free from the chains of worry and return to peace.',
      content: 'Anxiety tells us lies. It tells us we are not safe, that something terrible is about to happen, that we cannot cope. But you can. And you will.\n\nBegin by placing one hand on your heart and one on your belly. Feel the rhythm of your breath. This rhythm is your anchor.\n\nNow, imagine your anxious thoughts as clouds passing through a vast sky. You are not the clouds. You are the sky — vast, open, unchanging. The clouds will pass. They always do.\n\nWith each breath, feel yourself expanding. Feel the space between your thoughts growing larger. In this space, there is peace. There is calm. There is you.',
      category: 'guided-meditations',
    },
    {
      id: 'balancing-chakras',
      libraryRef: '0cbc9a1c0572496ea8bf2b69124154f0',
      title: 'Balancing Chakras',
      date: 'November 28, 2025',
      comments: 1,
      image: 'https://images.unsplash.com/photo-1569171181721-31a9e143e579?w=600&q=80',
      excerpt: 'Align and balance your energy centers with this guided chakra meditation. Journey through each chakra from root to crown, restoring harmony and flow.',
      content: 'Let us begin a journey through your seven energy centers, restoring balance and harmony to each one.\n\nStart at the base of your spine — the Root Chakra. Visualize a vibrant red light here. This is your foundation, your sense of safety and belonging. Breathe into it. Feel grounded.\n\nMove up to your lower abdomen — the Sacral Chakra. A warm orange glow. This is your creativity, your passion, your emotional center. Let it flow freely.\n\nNow to your Solar Plexus — a bright yellow sun. Your personal power, your confidence. Feel it radiate.\n\nYour Heart Chakra glows green with love and compassion. Open it wide.\n\nThe Throat Chakra shines blue — your voice, your truth. Speak it clearly.\n\nYour Third Eye, indigo, sees beyond the surface. Trust your intuition.\n\nFinally, the Crown Chakra — violet light connecting you to the divine. You are one with everything.',
      category: 'guided-meditations',
    },
    {
      id: 'deep-breathing',
      libraryRef: 'e04919f2b02d4d249b97f0256383ff99',
      title: 'Deep Breathing',
      date: 'November 21, 2025',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1522075782449-e45a34f1ddfb?w=600&q=80',
      excerpt: 'Master the art of deep breathing with this guided practice. Learn to use your breath as a powerful tool for relaxation and stress relief.',
      content: 'Your breath is the most powerful tool you have for managing stress and finding calm. Let us practice together.\n\nSit comfortably with your spine straight. Rest your hands on your knees or in your lap.\n\nBreathe in through your nose for a count of 4... Hold for a count of 4... Breathe out through your mouth for a count of 6...\n\nAgain. In for 4... Hold for 4... Out for 6...\n\nNotice how your body begins to relax with each breath cycle. Your shoulders drop. Your jaw unclenches. Your mind quiets.\n\nContinue this pattern for as long as you need. Your breath is always available to you, a constant companion in every moment.',
      category: 'guided-meditations',
    },
    {
      id: 'a-peaceful-sleep',
      libraryRef: '39df40801b89438f893034908c356932',
      title: 'A Peaceful Sleep',
      date: 'November 21, 2025',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1528715471579-d1bcf0ba5e83?w=600&q=80',
      excerpt: 'Drift into a peaceful, restorative sleep with this gentle guided meditation. Release the day and surrender to rest.',
      content: 'It is time to rest. You have done enough today. Whatever was left undone can wait until tomorrow.\n\nLie down comfortably. Close your eyes. Let the weight of your body sink into the mattress.\n\nBegin to relax each part of your body, starting with your toes. Feel them become heavy and warm. Move up to your ankles, your calves, your knees. Each part becoming softer, more relaxed.\n\nContinue up through your thighs, your hips, your abdomen. Feel the gentle rise and fall of your breath. Your chest. Your shoulders. Your arms and hands. Your neck. Your jaw. Your eyes. The space between your eyebrows.\n\nYou are floating now. Safe. Peaceful. Let sleep come to you naturally, like a gentle wave carrying you to a beautiful dream.',
      category: 'guided-meditations',
    },
  ],
  sleep: [
    {
      id: 'waterfall',
      libraryRef: '52e50c40d8934df992e12eec24201e7f',
      title: 'Light Ambient Rain',
      date: 'November 21, 2025',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1589205597286-696026919a86?w=600&q=80',
      excerpt: 'Let the soothing sound of gentle rain carry you into a deep, restful sleep. A peaceful ambient soundscape for relaxation.',
      content: 'Close your eyes and imagine you are walking through a lush, green forest. The air is cool and fresh, carrying the scent of pine and earth.\n\nAs you walk deeper into the forest, you begin to hear it — the gentle roar of a waterfall in the distance. With each step, the sound grows louder, more soothing.\n\nYou emerge into a clearing and there it is — a magnificent waterfall cascading down smooth, moss-covered rocks into a crystal-clear pool. The mist from the waterfall touches your face like a gentle kiss.\n\nYou sit on a soft patch of grass near the pool. The rhythm of the falling water is hypnotic. Your eyes grow heavy. Your body is completely relaxed.\n\nLet the waterfall sing you to sleep...',
      category: 'sleep',
    },
    {
      id: 'waterfall-sounds',
      libraryRef: 'ab528d00a3a84902b8bb23332310ab19',
      title: 'Waterfall',
      date: 'November 21, 2025',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1767273133599-43e84ce85241?w=600&q=80',
      excerpt: 'Immerse yourself in the tranquil sounds of cascading water. Let this waterfall meditation guide you into peaceful, restorative sleep.',
      content: 'Close your eyes and transport yourself to a serene mountain waterfall. The water flows endlessly, creating a symphony of natural sound that washes away the stress of the day.\n\nFeel the cool mist on your skin. Hear the water as it crashes into the pool below, creating a constant, soothing rhythm. This is nature\'s lullaby, designed to calm your mind and relax your body.\n\nWith each breath, sink deeper into relaxation. The waterfall\'s song continues, steady and eternal, carrying you gently into the most peaceful sleep.\n\nLet go. Let the water carry away your worries. Rest now.',
      category: 'sleep',
    },
    {
      id: 'the-lost-soul',
      libraryRef: 'a5ad1b732702477caf998ca79521f582',
      title: 'The Lost Soul',
      date: 'November 21, 2025',
      comments: 1,
      image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=600&q=80',
      excerpt: 'A bedtime story about a wandering soul who discovers that being lost is sometimes the first step to being found.',
      content: 'Once upon a time, in a world between worlds, there lived a soul who had forgotten its name.\n\nThis soul wandered through misty valleys and over silver mountains, searching for something it could not quite remember. "Who am I?" it whispered to the wind. But the wind only sighed in response.\n\nOne evening, the soul came upon a garden filled with flowers that glowed like lanterns. In the center of the garden sat an old woman, weaving threads of starlight.\n\n"I am lost," said the soul.\n\nThe old woman smiled. "You are not lost, dear one. You are finding yourself. And that is the bravest journey of all."\n\nThe soul sat down beside the old woman and watched as she wove stories into the night sky. And slowly, gently, the soul began to remember...',
      category: 'sleep',
    },
    {
      id: 'underwater',
      libraryRef: '21545511a89d4dfa91fe5c04f9561459',
      title: 'Underwater',
      date: 'February 24, 2026',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1559825481-12a05cc00344?w=600&q=80',
      excerpt: 'Dive into a peaceful underwater world where time slows down and every worry dissolves. A sleep story of ocean depths and tranquility.',
      content: 'Imagine you are floating in warm, crystal-clear water. The surface above you sparkles with sunlight, creating dancing patterns of gold on the sandy ocean floor below.\n\nYou can breathe easily here. This is a magical place where the water holds you like a gentle embrace.\n\nColorful fish swim past you — blues, yellows, and shimmering greens. A sea turtle glides by slowly, inviting you to follow. You drift along, weightless and free.\n\nBeneath you, a garden of coral sways gently in the current. Anemones wave their soft tendrils like fingers reaching out to greet you.\n\nThe deeper you go, the quieter everything becomes. The only sound is the gentle pulse of the ocean, like a heartbeat. Your heartbeat. Slow and steady.\n\nFloat here as long as you wish. The ocean will hold you...',
      category: 'sleep',
    },
    {
      id: 'campfire',
      libraryRef: '6a623ccbedb147838fd9380429fba43b',
      title: 'Campfire',
      date: 'November 24, 2025',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1594102760818-ed9f4b5ae0d9?w=600&q=80',
      excerpt: 'Gather around a warm campfire under a starlit sky. Let the crackling flames and gentle warmth guide you into a deep, peaceful sleep.',
      content: 'The night is clear and the stars are impossibly bright. You are sitting beside a campfire in a peaceful meadow, far from the noise of the world.\n\nThe fire crackles and pops, sending tiny sparks up into the dark sky like miniature fireworks. The warmth of the flames wraps around you like a blanket.\n\nYou lean back and gaze up at the sky. The Milky Way stretches across the heavens in a river of light. You try to count the stars but there are too many — an endless ocean of light.\n\nThe fire hums its ancient song. The grass beneath you is soft and cool. Somewhere in the distance, an owl calls gently.\n\nYour eyes grow heavy. The warmth, the stars, the gentle sounds — they all conspire to carry you into the deepest, most peaceful sleep...',
      category: 'sleep',
    },
    {
      id: 'the-wisdom-of-the-whispering-woods',
      libraryRef: '52e50c40d8934df992e12eec24201e7f',
      title: 'The Wisdom Of The Whispering Woods',
      date: 'November 22, 2025',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1610044850302-07625664a2dc?w=600&q=80',
      excerpt: 'Enter an enchanted forest where ancient trees share their wisdom through gentle whispers. A magical sleep story of nature and wonder.',
      content: 'There is a forest that exists at the edge of dreams, where the trees are so old they remember the first sunrise.\n\nYou find yourself at the entrance of this forest. The trees are massive, their branches reaching up like arms embracing the sky. Soft moss covers everything in a carpet of emerald green.\n\nAs you step inside, you notice something magical — the trees are whispering. Not with words exactly, but with feelings, with ancient knowing.\n\nThe first tree whispers: "Patience. All things grow in their own time."\n\nThe second tree whispers: "Roots. Stay grounded, no matter how strong the wind."\n\nThe third tree whispers: "Let go. The leaves that fall make room for new growth."\n\nYou walk deeper into the woods, each tree sharing its wisdom. The light filters through the canopy in golden rays. You feel a peace so deep, so complete, that your eyes close naturally.\n\nThe forest holds you safe as you drift into sleep...',
      category: 'sleep',
    },
  ],
  anxiety: [
    {
      id: 'evening-breathing',
      libraryRef: 'e04919f2b02d4d249b97f0256383ff99',
      title: 'Evening Breathing',
      date: 'December 7, 2025',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1507400492013-162706c8c05e?w=600&q=80',
      excerpt: 'Wind down your evening with this calming breathing exercise. Release the tension of the day and prepare your mind and body for restful sleep.',
      content: 'The day is done. Whatever happened today — the wins, the struggles, the mundane — it is all behind you now. This evening breathing practice will help you release it all.\n\nSit comfortably or lie down. Place your hands on your belly.\n\nBreathe in slowly through your nose for 4 counts, feeling your belly rise...\nHold gently for 2 counts...\nBreathe out through your mouth for 6 counts, feeling your belly fall...\n\nWith each exhale, imagine releasing one worry from the day. Let it float away like a leaf on a stream.\n\nContinue for 5-10 minutes. Feel the tension leaving your shoulders, your jaw, your forehead. You are safe. You are at peace. The night is yours for rest.',
      category: 'anxiety',
    },
    {
      id: 'mid-day-breathing',
      libraryRef: 'e04919f2b02d4d249b97f0256383ff99',
      title: 'Mid-Day Breathing',
      date: 'December 7, 2025',
      comments: 0,
      image: 'https://images.pexels.com/photos/1284296/pexels-photo-1284296.jpeg?w=600',
      excerpt: 'A mid-day reset for when life gets overwhelming. This breathing exercise helps you find calm in the middle of chaos.',
      content: 'It is the middle of the day and you need a reset. That is okay. Taking a pause is not a weakness — it is wisdom.\n\nWherever you are, take a moment. You can do this at your desk, in your car, or even in a restroom. Close your eyes if you can.\n\nBox Breathing: Breathe in for 4 counts... Hold for 4 counts... Breathe out for 4 counts... Hold for 4 counts...\n\nRepeat this pattern 4 times. Notice how your heartbeat slows. Notice how your thoughts become clearer.\n\nYou are not behind. You are not failing. You are simply human, and humans need to breathe. Take this moment. It is yours.',
      category: 'anxiety',
    },
    {
      id: 'morning-breathing',
      libraryRef: 'e04919f2b02d4d249b97f0256383ff99',
      title: 'Morning Breathing',
      date: 'December 6, 2025',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1470252649378-9c29740c9fa8?w=600&q=80',
      excerpt: 'Start your day with intention and calm. This morning breathing exercise sets a peaceful tone for everything that follows.',
      content: 'Good morning. Before the world rushes in with its demands, take this moment for yourself.\n\nSit up in bed or find a comfortable seated position. Close your eyes. Feel the newness of this day — fresh, untouched, full of possibility.\n\nEnergizing Breath: Breathe in through your nose for 4 counts, filling your lungs completely...\nHold for 2 counts, feeling the energy build...\nBreathe out through your mouth for 4 counts with a gentle "ahh" sound...\n\nRepeat 5 times. With each breath, feel yourself becoming more alert, more present, more ready for the day ahead.\n\nSet an intention: "Today, I choose peace over panic. I choose presence over perfection. I choose me."',
      category: 'anxiety',
    },
    {
      id: 'anxiety-breathing',
      libraryRef: 'e04919f2b02d4d249b97f0256383ff99',
      title: 'Anxiety',
      date: 'April 4, 2026',
      comments: 0,
      image: 'https://images.unsplash.com/photo-1530053969600-caed2596d242?w=600&q=80',
      excerpt: 'When anxiety strikes, your breath is your anchor. This guided breathing exercise helps you break free from the cycle of anxious thoughts.',
      content: 'Anxiety can feel like being trapped in a storm. But you have an anchor — your breath.\n\nRight now, wherever you are, try the 5-4-3-2-1 grounding technique:\n\n5 things you can SEE — Look around and name them.\n4 things you can TOUCH — Feel the textures around you.\n3 things you can HEAR — Listen carefully.\n2 things you can SMELL — Notice the scents.\n1 thing you can TASTE — What flavor is in your mouth?\n\nNow breathe: In for 4... Out for 7...\nIn for 4... Out for 7...\n\nYou are here. You are present. You are safe. The storm will pass. It always does.',
      category: 'anxiety',
    },
  ],
};

// 60 custom breathing exercises grouped into 6 categories.
// Each exercise: { id, name, inhale, hold (optional), exhale } — all in seconds.
export const breathingGroups = [
  {
    id: 'calm-stress-relief',
    name: 'Calm & Stress Relief',
    description: 'Slow, soothing rhythms to settle your nervous system.',
    accent: '#34d399',
    exercises: [
      { id: 'gentle-calm-circle', name: 'Gentle Calm Circle', inhale: 4, exhale: 6 },
      { id: 'soft-reset-breath', name: 'Soft Reset Breath', inhale: 5, exhale: 5 },
      { id: 'long-exhale-relaxation', name: 'Long Exhale Relaxation', inhale: 3, exhale: 7 },
      { id: 'tension-release-circle', name: 'Tension Release Circle', inhale: 4, hold: 2, exhale: 6 },
      { id: 'quiet-mind-breathing', name: 'Quiet Mind Breathing', inhale: 5, exhale: 7 },
      { id: 'grounding-breath', name: 'Grounding Breath', inhale: 4, hold: 1, exhale: 5 },
      { id: 'anxiety-ease-breath', name: 'Anxiety Ease Breath', inhale: 4, exhale: 8 },
      { id: 'shoulder-relax-breath', name: 'Shoulder Relax Breath', inhale: 5, exhale: 6 },
      { id: 'gentle-wave-circle', name: 'Gentle Wave Circle', inhale: 6, exhale: 6 },
      { id: 'deep-calm-reset', name: 'Deep Calm Reset', inhale: 4, hold: 4, exhale: 4 },
    ],
  },
  {
    id: 'focus-productivity',
    name: 'Focus & Productivity',
    description: 'Balanced cadences to sharpen attention and clear thoughts.',
    accent: '#60a5fa',
    exercises: [
      { id: 'focus-flow-breath', name: 'Focus Flow Breath', inhale: 4, exhale: 4 },
      { id: 'clarity-circle', name: 'Clarity Circle', inhale: 5, exhale: 4 },
      { id: 'attention-reset', name: 'Attention Reset', inhale: 4, hold: 2, exhale: 4 },
      { id: 'concentration-breath', name: 'Concentration Breath', inhale: 3, exhale: 3 },
      { id: 'present-moment-circle', name: 'Present Moment Circle', inhale: 6, exhale: 4 },
      { id: 'meeting-prep-breath', name: 'Meeting Prep Breath', inhale: 4, hold: 4, exhale: 6 },
      { id: 'productivity-pulse', name: 'Productivity Pulse', inhale: 5, hold: 1, exhale: 5 },
      { id: 'clear-thoughts-breath', name: 'Clear Thoughts Breath', inhale: 4, exhale: 5 },
      { id: 'mental-energy-circle', name: 'Mental Energy Circle', inhale: 3, hold: 2, exhale: 4 },
      { id: 'balanced-mind-breath', name: 'Balanced Mind Breath', inhale: 5, exhale: 5 },
    ],
  },
  {
    id: 'energy-boosting',
    name: 'Energy Boosting',
    description: 'Brisk, awakening breaths to lift your mood and energy.',
    accent: '#fbbf24',
    exercises: [
      { id: 'morning-wake-up-breath', name: 'Morning Wake-Up Breath', inhale: 3, exhale: 3 },
      { id: 'energizing-circle', name: 'Energizing Circle', inhale: 4, exhale: 3 },
      { id: 'midday-refresh-breath', name: 'Midday Refresh Breath', inhale: 5, exhale: 4 },
      { id: 'alertness-breath', name: 'Alertness Breath', inhale: 2, exhale: 4 },
      { id: 'recharge-circle', name: 'Recharge Circle', inhale: 6, exhale: 5 },
      { id: 'standing-energy-breath', name: 'Standing Energy Breath', inhale: 4, hold: 1, exhale: 4 },
      { id: 'open-chest-breath', name: 'Open Chest Breath', inhale: 5, exhale: 3 },
      { id: 'bright-focus-circle', name: 'Bright Focus Circle', inhale: 3, hold: 2, exhale: 3 },
      { id: 'motivation-breath', name: 'Motivation Breath', inhale: 4, exhale: 4 },
      { id: 'full-reset-breath', name: 'Full Reset Breath', inhale: 6, hold: 2, exhale: 6 },
    ],
  },
  {
    id: 'anxiety-overwhelm-relief',
    name: 'Anxiety & Overwhelm Relief',
    description: 'Extended exhales to switch off the stress response.',
    accent: '#a78bfa',
    exercises: [
      { id: 'safe-space-breath', name: 'Safe Space Breath', inhale: 4, exhale: 7 },
      { id: 'slow-down-circle', name: 'Slow Down Circle', inhale: 5, exhale: 8 },
      { id: 'emotional-reset-breath', name: 'Emotional Reset Breath', inhale: 4, hold: 2, exhale: 6 },
      { id: 'calm-response-breath', name: 'Calm Response Breath', inhale: 3, exhale: 5 },
      { id: 'pressure-release-circle', name: 'Pressure Release Circle', inhale: 5, exhale: 7 },
      { id: 'gentle-recovery-breath', name: 'Gentle Recovery Breath', inhale: 6, exhale: 6 },
      { id: 'quiet-confidence-breath', name: 'Quiet Confidence Breath', inhale: 4, hold: 1, exhale: 5 },
      { id: 'emotional-balance-circle', name: 'Emotional Balance Circle', inhale: 5, hold: 5, exhale: 5 },
      { id: 'heart-calm-breath', name: 'Heart Calm Breath', inhale: 4, exhale: 8 },
      { id: 'release-relax-breath', name: 'Release & Relax Breath', inhale: 5, exhale: 6 },
    ],
  },
  {
    id: 'end-of-day-breathing',
    name: 'End-of-Day Breathing',
    description: 'Wind-down patterns to release the day and ease into rest.',
    accent: '#f472b6',
    exercises: [
      { id: 'workday-release-circle', name: 'Workday Release Circle', inhale: 4, exhale: 7 },
      { id: 'evening-transition-breath', name: 'Evening Transition Breath', inhale: 5, exhale: 5 },
      { id: 'screen-break-breath', name: 'Screen Break Breath', inhale: 6, exhale: 6 },
      { id: 'mental-declutter-circle', name: 'Mental Declutter Circle', inhale: 4, hold: 2, exhale: 7 },
      { id: 'peaceful-pause-breath', name: 'Peaceful Pause Breath', inhale: 5, exhale: 8 },
      { id: 'restorative-breath', name: 'Restorative Breath', inhale: 6, hold: 2, exhale: 6 },
      { id: 'soft-landing-breath', name: 'Soft Landing Breath', inhale: 4, exhale: 5 },
      { id: 'gentle-closing-circle', name: 'Gentle Closing Circle', inhale: 5, exhale: 6 },
      { id: 'unwind-breath', name: 'Unwind Breath', inhale: 4, hold: 4, exhale: 6 },
      { id: 'let-go-breath', name: 'Let Go Breath', inhale: 3, exhale: 7 },
    ],
  },
  {
    id: 'ultra-simple-desk-breaths',
    name: 'Ultra Simple Desk Breaths',
    description: 'Quick, no-fuss rhythms you can do at your desk in seconds.',
    accent: '#fb923c',
    exercises: [
      { id: '4-in-4-out', name: '4-In / 4-Out', inhale: 4, exhale: 4 },
      { id: '5-in-5-out', name: '5-In / 5-Out', inhale: 5, exhale: 5 },
      { id: '3-in-6-out', name: '3-In / 6-Out', inhale: 3, exhale: 6 },
      { id: '6-in-6-out', name: '6-In / 6-Out', inhale: 6, exhale: 6 },
      { id: '4-4-4-box-breath', name: '4-4-4 Box Breath', inhale: 4, hold: 4, exhale: 4 },
      { id: '5-5-5-calm-breath', name: '5-5-5 Calm Breath', inhale: 5, hold: 5, exhale: 5 },
      { id: 'relaxation-ladder', name: 'Relaxation Ladder', inhale: 4, exhale: 8 },
      { id: 'simple-reset-circle', name: 'Simple Reset Circle', inhale: 3, exhale: 3 },
      { id: 'ground-and-breathe', name: 'Ground & Breathe', inhale: 5, exhale: 7 },
      { id: 'final-calm-breath', name: 'Final Calm Breath', inhale: 6, exhale: 8 },
    ],
  },
];

export const getAllBreathingExercises = () =>
  breathingGroups.flatMap((g) => g.exercises.map((e) => ({ ...e, groupId: g.id, groupName: g.name, accent: g.accent })));

export const getBreathingExerciseById = (id) => {
  for (const g of breathingGroups) {
    const ex = g.exercises.find((e) => e.id === id);
    if (ex) return { ...ex, groupId: g.id, groupName: g.name, accent: g.accent };
  }
  return null;
};

export const siteInfo = {
  name: 'Reflections by Rowdy',
  shortName: 'RBR',
  logo: null,
  description: 'A space for guided meditations, sleep stories, affirmations, and anxiety relief. Find peace, one reflection at a time.',
  social: {
    facebook: '#',
    instagram: '#',
    twitter: '#',
    youtube: '#',
  },
};

export const getAllPosts = () => {
  return Object.values(posts).flat();
};

export const getPostById = (id) => {
  const allPosts = getAllPosts();
  return allPosts.find((post) => post.id === id);
};

export const getPostsByCategory = (categoryId) => {
  return posts[categoryId] || [];
};

export const getCategoryName = (categoryId) => {
  const cat = categories.find((c) => c.id === categoryId);
  return cat ? cat.name : categoryId;
};
